import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-luxon';

let isChartJsRegistered = false;

/** Central Chart.js plugin registration for panel + installer apps. */
export function registerUbiChartJs(): void {
  if (isChartJsRegistered) {
    return;
  }

  Chart.register(...registerables, annotationPlugin, zoomPlugin);
  isChartJsRegistered = true;
}

export function provideUbiCharts() {
  registerUbiChartJs();
  return provideCharts(withDefaultRegisterables(annotationPlugin, zoomPlugin));
}
